import { render, staticRenderFns } from "./IntegrationBuilder.vue?vue&type=template&id=a2308c02&scoped=true"
import script from "./IntegrationBuilder.vue?vue&type=script&lang=js"
export * from "./IntegrationBuilder.vue?vue&type=script&lang=js"
import style0 from "./IntegrationBuilder.vue?vue&type=style&index=0&id=a2308c02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2308c02",
  null
  
)

export default component.exports